<template>
  <v-dialog
    hide-overlay
    :overlay-opacity="0"
    :transition="false"
    persistent
    ref="dialog"
    width="561px"
    :value="!!isOpen"
    absolute
  >
    <div class="card-overlay" @click="onOverlayClick"/>

    <v-card style="width: 561px" v-if="isOpen">
      <template v-if="selectedTheme !== undefined && Object.keys(selectedTheme).length && selectedTheme.screenshot_url">
        <v-img
          height="285px"
          width="100%"
          position="top center"
          :src="selectedTheme.screenshot_url"
        />
        <v-divider/>
      </template>
      <v-card-text class="px-10 pt-8">
        <v-btn
          v-if="!loading"
          :disabled="loading"
          x-small
          icon
          @click="closeModal"
          class="close-model"
          :class="{ 'btn-loading-block': loading }"
        >
          <v-icon>$close</v-icon>
        </v-btn>
        <h6>{{ $t("heading.onboarding.chooseProduct.domain.title") }}</h6>
        <p class="p-3 mt-2">
          {{ $t("heading.onboarding.chooseProduct.domain.subtitle") }}
        </p>
        <v-form ref="domainForm" @submit.prevent="onEnter">
          <v-text-field
            outlined
            :placeholder="$t('form.placeholder.domain')"
            v-model="domain"
            :rules="domainRulesWithBlacklist"
            class="v-input--lg"
            large
            validate-on-blur
            :disabled="loading"
            @keydown.enter.prevent="onEnter"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex flex-column pb-4 px-10 pt-2">
        <v-btn
          x-large
          elevation="0"
          @click="selectDomain()"
          :loading="loading"
          color="primary"
          block
        >
          <template
            v-if="this.isSelectedServiceServerAllowTransferDomain() || this.hasSelectedServiceInstantVerificationEnabled()">
            <span>{{ $t("button.continue") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
          <template v-else-if="hasSelectedServiceAskForSiteName()">
            <span>{{ $t("button.website.set") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
          <template v-else>
            <span>{{ $t("button.website.create") }}</span>
            <v-icon size="24" class="ml-2">$arrowright</v-icon>
          </template>
        </v-btn>
        <v-btn
          v-if="services.length > 1"
          :disabled="loading"
          @click="$emit('change-service-button-clicked')"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
          <span class="p-1 font-weight-light gray--text text--darken-1">
            {{ $t("button.service.change") }}
          </span>
        </v-btn>
        <v-btn
          v-else-if="canSelectedServiceChooseTheme()"
          :disabled="loading"
          @click="$emit('change-theme-button-clicked')"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
          <span class="p-2 font-weight-light gray--text text--darken-1">
            {{ $t("button.theme.change") }}
          </span>
        </v-btn>
        <v-btn
          v-else
          :disabled="loading"
          @click="closeModal"
          x-large
          elevation="0"
          class="mx-0 mt-2"
          color="gray"
          text
          block
        >
          <span class="p-2 font-weight-light gray--text text--darken-1">
            {{ $t("button.maybeLater") }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormRulesMixin from "../../mixins/FormRulesMixin";
import OnboardingSelectedServiceMixin from "../../mixins/OnboardingSelectedServiceMixin";

export default {
  mixins: [FormRulesMixin, OnboardingSelectedServiceMixin],
  data: function () {
    return {
      domain: "",
    };
  },
  props: {
    isOpen: [Boolean, String],
    loading: Boolean,
    selectedTheme: Object,
    services: Array,
    selectedService: Object,
  },
  computed: {
    domainRulesWithBlacklist() {
      const blacklist = this.preSelectedService?.onboarding?.domains_blacklist || [];

      const blacklistRule = (value) => {
        if (!value) return true;

        const domain = value.toLowerCase().trim();
        const isBlacklisted = blacklist.some(blacklistedDomain => {
          const escapedDomain = blacklistedDomain
            .toLowerCase()
            .replace(/\./g, '\\.')
            .replace(/\*/g, '.*');

          const blacklistRegex = new RegExp(`^${escapedDomain}$|\\.(${escapedDomain})$`);

          return blacklistRegex.test(domain);
        });

        return !isBlacklisted || this.$t('form.validation.domain.blacklisted');
      };

      return [...this.domainRulesTld, blacklistRule];
    }
  },
  methods: {
    closeModal() {
      if (!this.loading) {
        this.$emit('remove-modal');
      }
    },
    onOverlayClick() {
      if (!this.loading && this.$refs.dialog) {
        this.$refs.dialog.animateClick();
      }
    },
    onEnter() {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      this.$nextTick(() => {
        this.selectDomain();
      });
    },
    selectDomain() {
      if (this.loading) return;
      if (!this.$refs.domainForm.validate()) {
        return;
      }
      this.$emit('domain-selected', this.domain);
    }
  },
  watch: {
    isOpen: function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card::v-deep {
  .v-card__text {
    -webkit-line-clamp: unset !important;
  }

  @media (max-width: 480px) {
    .v-card__text,
    .v-card__actions {
      padding-left: 24px !important;
      padding-right: 24px !important;
    }
  }
}

.custom-dropdown-select--onboarding {
  display: none !important;
}

.v-input::v-deep {
  &.v-select.v-input--lg {
    .v-input__control .v-input__slot {
      min-height: 56px;
      max-height: fit-content;
      border-radius: 8px;

      input {
        display: none;
      }
    }
  }
}

.v-input::v-deep {
  &.v-input--lg {
    .v-input__control .v-input__slot {
      border-radius: 8px;
    }
  }
}

.v-dialog__content::v-deep {
  .v-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>

<style lang="scss">
.close-model {
  position: absolute;
  top: -40px;
  right: -8px;
}

.custom-dropdown-select--onboarding::v-deep {
  overflow-y: auto !important;
  padding-left: 16px;

  .v-list-item {
    color: unset !important;
    caret-color: unset !important;
  }
}
</style>